import { render } from "./trueOrFalse.vue?vue&type=template&id=1966854a&scoped=true"
import script from "./trueOrFalse.vue?vue&type=script&lang=js"
export * from "./trueOrFalse.vue?vue&type=script&lang=js"

import "./trueOrFalse.vue?vue&type=style&index=0&id=1966854a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1966854a"]])

export default __exports__